import React from 'react'
import { useTranslation } from 'language/translator'

import Badge from 'components_new/atoms/Badge'
import Box from 'components_new/atoms/Box'
import Icon, { IconName } from 'components_new/atoms/Icon'
import Tag from 'components_new/atoms/Tag'
import Text from 'components_new/atoms/Text'
import Tooltip from 'components_new/atoms/Tooltip'

import { ElementType } from 'types/GlobalWidget'

interface DragItem {
  hidden: boolean
  iconName: IconName
  index: number
  sx?: object
  showType?: boolean
  title: string
  type?: ElementType
}

const DragItem = (props: DragItem) => {
  const { hidden, iconName, index, showType, title, type } = props
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        px: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}
    >
      <Tooltip
        title={
          index !== 0 ? (
            ''
          ) : (
            <>
              {t('widgets', 'primary_metric_tooltip')}
            </>
          )
        }
      >
        <Badge color="success" variant="dot" invisible={index !== 0}>
          <Icon name={iconName} color="disabled" />
        </Badge>
      </Tooltip>
      <Text
        sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
        variant="subtitle2"
      >
        {title}
      </Text>
      {showType ? (
        <>
          <Tooltip
            placement={'top'}
            title={type === ElementType.KPI ? t('widgets', 'metric') : t('widgets', 'attribute')}
          >
            <Box>
              <Tag
                startIconName={
                  type === ElementType.KPI
                    ? 'TrendingUpOutlined'
                    : 'SellOutlined'
                }
                color="primary"
              />
            </Box>
          </Tooltip>
          {hidden ? (
            <Tooltip placement={'top'} title={t('widgets', 'column_is_hidden')}>
              <Box>
                <Tag startIconName={'VisibilityOffOutlined'} color="primary" />
              </Box>
            </Tooltip>
          ) : null}
        </>
      ) : null}
    </Box>
  )
}

export default DragItem
